import enCommon from './en/common';
import enComponents from './en/components';
import enValidations from './en/validations';
import enFormat from './en/format';
import enStatus from './en/status';
import enErrors from './en/errors';
import enSubTopics from './en/subTopics';

import usCommon from './en-us/common';
import usComponents from './en-us/components';
import usValidations from './en-us/validations';
import usFormat from './en-us/format';
import usStatus from './en-us/status';
import usErrors from './en-us/errors';
import usSubTopics from './en-us/subTopics';

import deCommon from './de/common';
import deFormat from './de/format';
import deComponents from './de/components';
import deValidations from './de/validations';
import deStatus from './de/status';
import deErrors from './de/errors';
import deSubTopics from './de/subTopics';

import atCommon from './de-at/common';
import atFormat from './de-at/format';
import atComponents from './de-at/components';
import atValidations from './de-at/validations';
import atStatus from './de-at/status';
import atErrors from './de-at/errors';
import atSubTopics from './de-at/subTopics';

import caCommon from './en-ca/common';
import caComponents from './en-ca/components';
import caValidations from './en-ca/validations';
import caFormat from './en-ca/format';
import caStatus from './en-ca/status';
import caErrors from './en-ca/errors';
import caSubTopics from './en-ca/subTopics';

import nlCommon from './nl/common';
import nlFormat from './nl/format';
import nlComponents from './nl/components';
import nlValidations from './nl/validations';
import nlStatus from './nl/status';
import nlErrors from './nl/errors';
import nlSubTopics from './nl/subTopics';

export default {
    "en-us": {
        common: usCommon,
        components: usComponents,
        validations: usValidations,
        format: usFormat,
        status: usStatus,
        errors: usErrors,
        subTopics: usSubTopics
    },
    "en-ca": {
        common: caCommon,
        components: caComponents,
        validations: caValidations,
        format: caFormat,
        status: caStatus,
        errors: caErrors,
        subTopics: caSubTopics
    },
    en: {
        common: enCommon,
        components: enComponents,
        validations: enValidations,
        format: enFormat,
        status: enStatus,
        errors: enErrors,
        subTopics: enSubTopics
    },
    de: {
        common: deCommon,
        components: deComponents,
        validations: deValidations,
        format: deFormat,
        status: deStatus,
        errors: deErrors,
        subTopics: deSubTopics
    },
    "de-at": {
        common: atCommon,
        components: atComponents,
        validations: atValidations,
        format: atFormat,
        status: atStatus,
        errors: atErrors,
        subTopics: atSubTopics
    },
    nl: {
        common: nlCommon,
        components: nlComponents,
        validations: nlValidations,
        format: nlFormat,
        status: nlStatus,
        errors: nlErrors,
        subTopics: nlSubTopics
    }
};